export default "__VITE_ASSET__DsALxrlJ__"